import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames';

import { objectWithoutProperties, extendClass } from '../../../utils/utils'
import { toggleClasses, asideMenuCssClasses, checkBreakpoint, validBreakpoints } from './shared/index'


//================ Property Value Type =====================
const propType = {
    children:PropTypes.node,
    className: PropTypes.string,
    dispaly: PropTypes.string,
    defaultOpen: PropTypes.bool,
    tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
    type: PropTypes.string,
    mobile: PropTypes.bool
}

//================ Default Property Value =====================
const defaultProps = {
    className: "",
    dispaly: "lg",
    tag: "button",
    type: "button",
    defaultOpen: false,
    mobile: false
}


const AppAsideToggler = (props) => {

    // Similar to componentDidMount and componentDidUpdate:
    useEffect(() => {
        toggle(props.defaultOpen);
    });

    function toggle(force) {
        let display = props.display,
            mobile = props.mobile,
            cssClass = asideMenuCssClasses[0];

        if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
            cssClass = 'aside-menu-' + display + '-show';
        }

        toggleClasses(cssClass, asideMenuCssClasses, force);
    };

    const _props = props,
        className = _props.className,
        Tag = _props.tag,
        type = _props.type,
        children = _props.children,
        //defaultOpen=_props.defaultOpen,
        //attribute=objectWithoutProperties2(_props,'className','tag','children'),
        attribute = objectWithoutProperties(_props, 'className', 'tag', 'children', 'defaultOpen', 'dispaly', 'mobile'),
        classes = classNames(className, 'navbar-toggler');


    return React.createElement(
        Tag,
        extendClass(
            { type: type, className: classes },
            attribute,
            {
                onClick: (event) => {
                    event.preventDefault();
                    toggle();
                }
            }),
        children || React.createElement('span', { className: 'navbar-toggler-icon' })
    );

}





// export default class AppAsideToggler extends Component {

//     componentDidMount() {
//         this.toggle(this.props.defaultOpen);
//     };


//     toggle = (force) => {
//         let display = this.props.display,
//             mobile = this.props.mobile,
//             cssClass = asideMenuCssClasses[0];

//         if (!mobile && display && checkBreakpoint(display, validBreakpoints)) {
//             cssClass = 'aside-menu-' + display + '-show';
//         }

//         toggleClasses(cssClass, asideMenuCssClasses, force);
//     };


//     render() {

//         const _props = this.props,
//             className = _props.className,
//             Tag = _props.tag,
//             type = _props.type,
//             children = _props.children,
//             //defaultOpen=_props.defaultOpen,
//             //attribute=objectWithoutProperties2(_props,'className','tag','children'),
//             attribute = objectWithoutProperties(_props, 'className', 'tag', 'children', 'defaultOpen', 'dispaly', 'mobile'),
//             classes = classNames(className, 'navbar-toggler');

//         // delete attribute.defaultOpen;
//         // delete attribute.dispaly;
//         // delete attribute.mobile;

//         return React.createElement(
//             Tag,
//             extendClass(
//                 { type: type, className: classes },
//                 attribute,
//                 {
//                     onClick: (event) => {
//                         event.preventDefault();
//                         this.toggle();
//                     }
//                 }),
//             children || React.createElement('span', { className: 'navbar-toggler-icon' })
//         );


//     }
// }
export default AppAsideToggler;

AppAsideToggler.propTypes = propType;
AppAsideToggler.defaultProps = defaultProps;
